import { render, staticRenderFns } from "./UserRoutesManager.vue?vue&type=template&id=5e2936b4&"
import script from "./UserRoutesManager.vue?vue&type=script&lang=js&"
export * from "./UserRoutesManager.vue?vue&type=script&lang=js&"
import style0 from "./UserRoutesManager.vue?vue&type=style&index=0&id=5e2936b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports